/**
 * Created by zhaohaixi on 2018/10/8.
 */
/**
 * @function getZindex 获取当前zindex
 * @returns {number}
 */
import Cookie from 'js/lib/cookie.js'
import store from 'store'

export const UpdateTime = '2021年2月26日';
export function getZIndex() {
    let zIndex = 0;
    !window.LenovoData && (window.LenovoData = {});
    !window.LenovoData.ZIndex && (window.LenovoData.ZIndex = 1000);
    zIndex = window.LenovoData.ZIndex;
    window.LenovoData.ZIndex += 5; //以备下次使用
    return zIndex;
}

export function transFileInfo(info) {
    // return
}

/**
 * 获取文件夹类型
 * @param {boolean} type.is_team 团队
 * @param {boolean} type.is_shared 共享
 * @param {number} type.folder_dc_type 文件夹类型
 * @return 文件夹类型
 * */
export function getFolderType(type) {
    let typeIcon = "folder";
    let isShared = type.is_shared, isTeam = type.is_team, folderDcType = type.folder_dc_type
    if (isShared && !isTeam && folderDcType == 0) { //普通文件夹 共享
        typeIcon = "folder-share";
    }
    if (isShared && isTeam && folderDcType == 0) { //团队文件夹  如果是团队一定是共享
        typeIcon = "folder-team";
    }

    if (isShared && !isTeam && (folderDcType == 2 || folderDcType == 3)) {
        // typeIcon = "folder-share-oversea"; oversea 图标合并
        typeIcon = "folder-share";
    }
    if (isShared && !isTeam && folderDcType == 1) {
        typeIcon = 'folder-share-private';
    }

    if (isShared && isTeam && (folderDcType == 2 || folderDcType == 3)) {
        // typeIcon = 'folder-team-oversea'; oversea 图标合并
        typeIcon = 'folder-team';
    }
    if (isShared && isTeam && folderDcType == 1) {
        typeIcon = 'folder-team-private';
    }

    if (!isShared && !isTeam && (folderDcType == 2 || folderDcType == 3)) {
        // typeIcon = 'folder-oversea'; oversea 图标合并
        typeIcon = 'folder';
    }
    if (!isShared && !isTeam && folderDcType == 1) {
        typeIcon = 'folder-private';
    }
    if (isTeam && folderDcType == 4) {
        typeIcon = 'folder-team-hybrid';
    }
    if (isShared && isTeam && folderDcType == 4) {
        // typeIcon = 'folder-team-share-hybrid'; 根据设计图标合并
        typeIcon = 'folder-team-hybrid';
    }
    if (!isTeam && folderDcType == 4) {
        typeIcon = 'folder-hybrid';
    }
    if (isShared && !isTeam && folderDcType == 4) {
        typeIcon = 'folder-share-hybrid';
    }
    return typeIcon;
}

/**
 * 获取文件类型
 * @param {string} typeIcon mime格式
 * @returns {string} 文件类型
 */
export function typeIcon(typeIcon) {
    /* eslint-disable */
    let jar = { //oversea图标合并
        "folder_share_private": "folder_share_private",
        // "folder_team_oversea": "folder_team_oversea",
        "folder_team_private": "folder_team_private",
        // "folder_oversea": "folder_oversea",
        "folder_private": "folder_private",
        "folder_team": "folder_team",
        "folder_share": "folder_share",
        "folder": "folder",
        "": "folder",
        "doc": "word",
        "docx": "word",
        "rtf": "word",
        "dwg": "cad",
        "dxf": "cad",
        "dwt": "cad",
        "dws": "cad",
        "txt": "text",
        "jpg": "pic",
        "JPG": "pic",
        "jpeg": "pic",
        "JPEG": "pic",
        "png": "pic",
        "PNG": "pic",
        "bmp": "pic",
        "BMP": "pic",
        "gif": "pic",
        "GIF": "pic",
        "tif": "pic",
        "tiff": "pic",
        "TIFF": "pic",
        "pcx": "pic",
        "psd": "pic",
        "thm": "pic",
        "yuv": "pic",
        "pps": "ppt",
        "ppsx": "ppt",
        "ppt": "ppt",
        "pptx": "ppt",
        "xls": "excel",
        "xlsx": "excel",
        "xlsm": "excel",
        "csv": "excel",
        "lock": "lock",
        "pct": "pdf",
        "pdf": "pdf",
        "pmd": "pdf",
        "mp3": "music",
        "wma": "music",
        "ra": "music",
        "ram": "music",
        "ape": "music",
        "flac": "music",
        "wav": "music",
        "aac": "music",
        "ac3": "music",
        "amr": "music",
        "m4a": "music",
        "m4r": "music",
        "ogg": "music",
        "wv": "music",
        "mp2": "music",
        "avi": "video",
        "mov": "video",
        "mpg": "video",
        "mp4": "video",
        "mpeg": "video",
        "xv": "video",
        "3gp": "video",
        "divx": "video",
        "rm": "video",
        "rmvb": "video",
        "asf": "video",
        "wmv": "video",
        "vob": "video",
        "mkv": "video",
        "flv": "video",
        "3g2": "video",
        "asx": "video",
        "ts": "video",
        "m3u8": "video",
        "webm": "video",
        "exe": "exe",
        "rar": "zip",
        "zip": "zip",
        "zipx": "zip",
        "7z": "zip",
        "cab": "zip",
        "arj": "zip",
        "jar": "zip",
        "lzh": "zip",
        "bin": "zip",
        "deb": "zip",
        "gz": "zip",
        "rpm": "zip",
        "sit": "zip",
        "sitx": "zip",
        "tar": "zip",
        "cad": "cad",
        "ai": "ai",
        "dw": "dw",
        "fl": "fl",
        "id": "id",
        "ae": "ae",
        "3d": "3d",
        "eps": "svg",
        "svg": "svg",
        "cdr": "svg",
        " ": "other",
        "other": "other",
        "pages": "other",
        "log": "other",
        "msg": "other",
        "wps": "other",
        "xps": "other",
        "chm": "other",
        "pdg": "other",
        "key": "other",
        "dat": "other",
        "efx": "other",
        "sdf": "other",
        "vcf": "other",
        "wks": "other",
        "munbers": "other",
        "3dm": "other",
        "max": "other",
        "com": "other",
        "bat": "other",
        "scr": "other",
        "lib": "other",
        "app": "other",
        "cgi": "other",
        "gadget": "other",
        "vb": "other",
        "wsf": "other",
        "accdb": "other",
        "db": "other",
        "dbf": "other",
        "mdb": "other",
        "pdb": "other",
        "sql": "other",
        "cpl": "setting",
        "cur": "setting",
        "dll": "setting",
        "dmp": "setting",
        "drv": "setting",
        "lnk": "setting",
        "sys": "setting",
        "cfg": "setting",
        "ini": "setting",
        "keychain": "setting",
        "prf": "setting",
        "c": "cpp",
        "class": "cpp",
        "cpp": "cpp",
        "cs": "cpp",
        "dtd": "cpp",
        "fil": "cpp",
        "java": "cpp",
        "m": "cpp",
        "pl": "cpp",
        "py": "cpp",
        "html": "html",
        "htm": "html",
        "xhtml": "html",
        "php": "html",
        "css": "html",
        "js": "html",
        "xml": "html",
        "asp": "html",
        "cer": "html",
        "rss": "html",
        "ttf": "font",
        "fnt": "font",
        "otf": "font",
        "fon": "font",
        "dmg": "iso",
        "toast": "iso",
        "vcd": "iso",
        "iso": "iso",
        "part": "three_d",
        "PART": "three_d",
        "prt": "three_d",
        "PRT": "three_d",
        "asm": "three_d",
        "ASM": "three_d",
        "stp": "three_d",
        "STP": "three_d",
        "obj": "three_d",
        "OBJ": "three_d",
        "step": "three_d",
        "STEP": "three_d"
    };
    /* eslint-enable */
    for (let value in jar) {
        if (typeIcon === value) {
            return jar[value]
        }
    }
    return 'other'
}

/**
 * 元素是否滚动到底部
 * @param {jquery object} $html 滚动元素
 * @returns {boolean} 是否滚动到了底部
 */
export function scrollBottom($html) {
    let nDivHight = $html.height(),
        nScrollHight = $html[0].scrollHeight,
        nScrollTop = $html[0].scrollTop;
    return (nScrollTop + nDivHight == nScrollHight)
}

/*
 *判断是否为客户端（pc或者mac）
 */
export function isClient () {
    if (Cookie.get('Client-Agent')){
        return true;
    }
    return false;
}
/*
    判断客户端是pc还是mac
    * */
export function isPC() {
    if (Cookie.get('Client-Agent') && Cookie.get('Client-Agent').indexOf('LDClientWin') > -1) {
        return true;
    }
    return false;
}
export function isMac() {
    if (Cookie.get('Client-Agent') && Cookie.get('Client-Agent').indexOf('LDClientMac') > -1){
        return true;
    }
    return false;
}
/*
 * 判断是不是手机
 */
export function isMobile() {
    let deviceKeys=["iPhone","iPad","iPod","Android","Mobile","Linux","SymbianOS","BlackBerry","Phone"];
    for (let i = 0, len = deviceKeys.length; i < len; i++) {
        let index = navigator.userAgent.toLowerCase().indexOf(deviceKeys[i].toLowerCase());
        if (index != -1) {
            return true;
        }
    }
    return false;
}
/*
 *校验文件名称
 * */
export function validFilename (filename) {
    let reg = /[\/:*?"<>|\\]/;
    if (reg.test(filename)) {
        return false;
    }
    return true;
}
/*
 *校验文件夹名称
 * */
export function validFolderName (foldername) {
    let reg = /[\/:*?"<>|\\]/;
    if (reg.test(foldername)) {
        return false;
    }
    return true;
}
/*
 * 校验文件夹名称全是...
 * */
export function validFolderName2 (foldername) {
    if (foldername == '.' || foldername == '..') {
        return true;
    } else {
        return false;
    }
}
/*
 * 校验是否为数字
 * */
export function validNumber (number) {
    var reg = /^\d+$/;
    return reg.test(number);
}

/**
 * 获取用户权限名
 * @param {string} id 权限id
 */
export function resolveAuthName(id) {
    var authname = "";
    if (id > 3000) {
        return (authname = "自定义")
    }
    switch ("" + id) {
    case "1000":
        authname = "禁止访问"
        break;
    case "2009":
        authname = "预览者"
        break;
    case "2008":
        authname = "上传者"
        break;
    case "2007":
        authname = "上传/链接者"
        break;
    case "2006":
        authname = "下载者"
        break;
    case "2005":
        authname = "下载/链接者"
        break;
    case "2004":
        authname = "上传/下载者"
        break;
    case "2003":
        authname = "上传/下载/链接者"
        break;
    case "2010":
        authname = "更新/下载/链接者"
        break;
    case "2001":
        authname = "编辑者"
        break;
    case "2011":
        authname = "预览/上传/下载者"
        break;
    case "2012":
        authname = "预览/上传者"
        break;
    case "2013":
        authname = "无链接编辑者"
        break;
    case "2014":
        authname = "无删除编辑者"
        break;
    default:
        authname = "预览者"
    }
    return authname
}
/*
* 解析 具有什么样的权限
* @param access_mode {{Number}} 权限参数
* */
export function parseAccessMode(access_mode) {
    var action = [], atom = [];
    if (access_mode == 2047){
        action.push('edit');
    }
    if (access_mode == 1599) {
        action.push('upload');
        atom.push(2);
        action.push('download');
        atom.push(4);
        action.push('delivery');
        atom.push(24);
    }
    if (access_mode == 1575) {
        action.push('upload');
        atom.push(2);
        action.push('download');
        atom.push(4);
    }
    if (access_mode == 1565) {
        action.push('download');
        atom.push(4);
        action.push('delivery');
        atom.push(24);
    }
    if (access_mode == 1541) {
        action.push('download');
        atom.push(4);
    }
    if (access_mode == 1082) {
        action.push('upload');
        atom.push(2);
        action.push('delivery');
        atom.push(24);
    }
    if (access_mode == 1058) {
        action.push('upload');
        atom.push(2);
    }
    if (access_mode == 1025) {
        action.push('preview');
        atom.push(1);
    }
    if ((access_mode & 1) == 1) {
        action.push('preview');
        atom.push(1);
    }
    if ((access_mode & 2) == 2) {
        action.push('upload');
        atom.push(2);
    }
    if ((access_mode & 4) == 4) {
        action.push('download');
        atom.push(4);
    }
    if ((access_mode & 24) == 24) {
        action.push('delivery');
        atom.push(24);
    }
    if ((access_mode & 256) == 256) {
        action.push('move');
        atom.push(256);
    }
    if ((access_mode & 512) == 512) {
        action.push('copy');
        atom.push(512);
    }
    if ((access_mode & 128) == 128) {
        action.push('rename');
        atom.push(128);
    }
    if ((access_mode & 64) == 64) {
        action.push('delete');
        atom.push(64);
    }
    if ((access_mode & 32) == 32) {
        action.push('create');
        atom.push(32);
    }
    return {
        action: action,
        atom: atom
    };
}

/*
* 判断是否存在某一权限
* @param access_mode {{Number}} 权限编码
* @param access 权限
* @return 具有权限
* */
export function isHasAuth(access_mode, access) {
    var mode = parseAccessMode(access_mode);
    if (typeof  access == 'number') {
        var authList = mode['atom'];
    } else if (typeof access == 'string') {
        var authList = mode['action'];
    } else {
        var authList = mode['action'];
    }
    var index = authList.indexOf(access);
    return index > -1;
}

/*
* 判断是否有在线编辑功能
* 1.至少具有预览和上传和新建权限
*（在线编辑不是原子权限）
*/
export function hasEditOLAuth(access_mode) {
    if(store.getters.accountConfig){
        if (store.getters.accountConfig.ibm_docs_online_edit == "true") {
            return isHasAuth(access_mode, "preview") && isHasAuth(access_mode, "upload") && isHasAuth(access_mode, "create");
        }
    }else{
        return false;
    }
}

/*
* 判断是否可以显示锁定功能
* 1.至少具有下载和上传权限
* 2.具有编辑权限
*（锁定不是原子权限）
*/
export function hasLock(access_mode) {
    const auth = parseAccessMode(access_mode).action.join('');
    return /download/.test(auth) && /upload/.test(auth) || /edit/.test(auth);
}

export function haveDirAuth(fileObj) {
    return isAdmin() || (fileObj && fileObj.authable);
}

export function isOwner(creator) {
    return window.LenovoData && window.LenovoData.user.user_info.user_name == creator;
}

export function isAdmin() {
    if(isEntVersion()){
        let entRole =store.state.lenovoData.userInfo.entRole;

        return entRole.indexOf("super_admin") !== -1;
    }
    return store.getters.userInfo && store.getters.userInfo.role === "admin";
}

export function supportDelivery() {
    return store.getters.accountConfig.delivery_support;
}
export function isEntVersion() {
    return store.state.lenovoData&&store.state.lenovoData.session&&store.state.lenovoData.session.accountManageMode === "enterprise";
}
/*
* 判断是否能够添加和编辑标签
* 1.具有编辑者权限
*
* */
export function canTag(access_mode) {
    return isHasAuth(access_mode, "edit");
}
/**
 * 文件是否能预览
 */
export function canPreview(mime) {
    return /\.(doc|pdf|txt|wps|mpp|dps|vsd|et|vsdx|ppt|xls|docx|pptx|xlsx|png|jpeg|jpg|gif|bmp|pic|word|excel|psd|tiff|tif|eps|ai|dwg|dxf|dwt|dws|step|stp|prt|asm|part|obj|avi|mov|mpg|mp4|mpeg|3gp|rm|rmvb|asf|wmv|mkv|flv|m3u8|ts|webm|mp3|wma|ra|ram|ape|flac|wav|aac|ac3|amr|m4a|m4r|ogg|wv|mp2)$/.test(mime);
}

export function getPrivatePrivilege(cssAction) {
    //自定义权限定义什么就是什么权限，都是单个原子权限
    //组合权限则可能不一定具有本身的权限
    //eg:上传者可以有创建目录的权限
    //eg:下载者可以预览还可以复制，仅仅下载又无法预览和复制，
    //    所以要剔除原子下载权限(download0)
    return {
        canPreview: /preview|edit|download\b|download-\w+/.test(cssAction),
        canUpload: /upload|edit/.test(cssAction),
        canDownload: /download|edit/.test(cssAction),
        canLink: /delivery|edit/.test(cssAction),
        canCreate: /create|edit|upload\b|upload-\w+/.test(cssAction),
        canDelete: /delete|edit/.test(cssAction),
        canRename: /rename|edit/.test(cssAction),
        canMove: /move|edit/.test(cssAction),
        canCopy: /copy|download\b|download-\w+|edit/.test(cssAction)
    };
}
/**
 * 时间格式化
 * @param {string|Date} date 时间戳或者时间对象
 * @param {string} format 时间格式
 */
export function formatDate(dateObj, fmt) {
           let year, month, date, hours, minutes, seconds;
           if (!dateObj) return;
           if (
               Object.prototype.toString.call(dateObj) == "[object Date]"
           ) {
               year = dateObj.getFullYear();
               month = dateObj.getMonth() + 1;
               date = dateObj.getDate();
               hours = dateObj.getHours();
               minutes = dateObj.getMinutes();
               seconds = dateObj.getSeconds();
           } else {
               let regexp = /([\d]{4})-([\d]{2})-([\d]{2})T([\d]{2}):([\d]{2}):([\d]{2})(?:\+([\d]{2}):([\d]{2}))?/;
               let d = regexp.exec(dateObj);
               if (!d) return;
               (year = d[1]),
                   (month = d[2]),
                   (date = d[3]),
                   (hours = d[4]),
                   (minutes = d[5]),
                   (seconds = d[6]);
           }
           let o = {
               "M+": +month, //月份
               "d+": +date, //日
               "h+": +hours, //小时
               "m+": +minutes, //分
               "s+": +seconds, //秒
               "q+": Math.floor((+month + 3) / 3) //季度
               //"S": d.getMilliseconds() //毫秒
           };
           if (/(y+)/.test(fmt))
               fmt = fmt.replace(
                   RegExp.$1,
                   (year + "").substr(4 - RegExp.$1.length)
               );
           for (let k in o)
               if (new RegExp("(" + k + ")").test(fmt))
                   fmt = fmt.replace(
                       RegExp.$1,
                       RegExp.$1.length == 1
                           ? o[k]
                           : ("00" + o[k]).substr(("" + o[k]).length)
                   );
           return fmt;
       }

/**
 *
 * @param {ElemetNode} elem
 * @param {string} type 仅支持 'height'和'width'
 */
export function getWidthOrHeight( elem, type ) {
    if (!elem) return 0;
    const showCss = {display:'block',visibility:'hidden',position:'absolute'};
    let view = elem.ownerDocument.defaultView || window,
        computed = view.getComputedStyle(elem),
        Type = 'offset' + type.replace(/^([a-z])/,str=>str.toUpperCase()),
        reg=/[^\d]+/g,
        ret = undefined,
        prop;
    if( computed ) {
         prop = computed.getPropertyValue(type);
        if( !prop.replace( reg , '' ) && !elem[Type] ) {
            styleSwap(elem, showCss, function(elem){
                ret = elem[Type];
            })
        } else {
            ret = elem[Type];
        }
    } else {
        prop = elem.style[type];
        if( !prop.replace( reg , '' ) && elem[Type] ) {
            styleSwap( elem, showCss, function(elem){
                ret = elem[Type];
            })
        } else {
            ret = elem[Type];
        }
    }
    return ret;
}

export function styleSwap(elem,styleObj,calllback){
    var oldStyle={};
    for(var key in styleObj){
        oldStyle[key] = elem.style[key];
        elem.style[key] = styleObj[key];
    }
    calllback(elem);
    for(var name in oldStyle){
        elem.style[name] = oldStyle[name];
    }
}

/*
* 文件能否在线编辑
* */
export function canEditOL(mime) {
    return /\.doc|ppt|xls/.test(mime);
}

/*
* 当前元素是否聚焦
* */
export function hasFoucs(element) {
    return document.activeElement === element;
}
//格式化文件大小
export function formatBytes (baseNumber) {
    let i, unit, unitLabel,
        unitDivisors = [1099511627776, 1073741824, 1048576, 1024, 1],
        unitLabels = ["TB", "GB", "MB", "KB", "B"];
    if (baseNumber === 0) {
        return "0 " + unitLabels[unitLabels.length - 1];
    }

        unit = baseNumber;
        unitLabel = unitLabels.length >= unitDivisors.length ? unitLabels[unitDivisors.length - 1] : "";
        for (i = 0; i < unitDivisors.length; i++) {
            if (baseNumber >= unitDivisors[i]) {
                unit = (baseNumber / unitDivisors[i]).toFixed(2);
                unitLabel = unitLabels.length >= i ? " " + unitLabels[i] : "";
                break;
            }
        }
        return unit + unitLabel;
}

export function getApiVersion() {
    return '/v2';
}

/*
* 数值与单位
* @return quota
* */
export function getQuotaValue(num, unit) {
    let value = 1;
    num = num || 0;
    unit = unit || 'MB';
    if (num == 0)
        return 0;
    switch (unit.toLowerCase()) {
        case 'b':
            value *= Math.pow(2, 0);
            break;
        case 'kb':
            value *= Math.pow(2, 10);
            break;
        case 'mb':
            value *= Math.pow(2, 20);
            break;
        case 'gb':
            value *= Math.pow(2, 30);
            break;
        case 'tb':
            value *= Math.pow(2, 40);
            break;
        default:
            value *= Math.pow(2, 20);
            break;
    }
    return num * value;
}
/*
* 重新修复单位
* */
export function getValueUnit(baseNumber) {
    let unitDivisors = [1073741824, 1048576, 1024, 1],
        unitLabels = ["GB", "MB", "KB", "B"],
        i, unit, unitDivisor, unitLabel, len;

    if (baseNumber == 0) {
        return {
            value: 0,
            unit: unitLabels[1],
            str: '0 ' + unitLabels[1]
        }
    }

    unit = baseNumber;
    unitLabel = unitLabels.length >= unitDivisors.length ? unitLabels[unitDivisors.length - 1] : "";
    for (i = 0, len = unitDivisors.length; i < len && i < 2; i++) {
        if (baseNumber >= unitDivisors[i]) {
            unit = (baseNumber / unitDivisors[i]);
            unitLabel = unitLabels.length >= i ? unitLabels[i] : "";
            if (parseInt(unit) == unit)
                break;
        }
    }

    return {
        value: parseInt(unit),
        unit: unitLabel,
        str: unit + " " + unitLabel
    }
}
//校验密码
// 1. 至少包含字母、数字、符号三种中的两种。
// 2. 字母、大写字母都算字母一种。
// 3. 字符包含英文键盘可输入的字符，不包含中文标点   -=~!@#$%^&*()_+[]{}\|;:'",<.>/?
export function validPasword(value) {
    const mtest =/^(?![0-9]+$)(?![A-Za-z]+$)(?![~!\\\$\^\*\(\)\+\[\]\.\{\}\|\?\,\&@#%_;':\"<>=`-]+$)[0-9A-Za-z~!\\\$\^\*\(\)\+\[\]\.\{\}\|\?\,\&@#%_;':\"<>=`-]{6,32}$/;
    return mtest.test(value);
}
/*校验手机号地址*/
export function validPhone(value) {
    var mtest = /^1[3-9]\d{9}$/;
    return mtest.test(value);
}

export function isInternetExplorer9() {
    let b_version = navigator.appVersion;
    let version = b_version.split(";");
    if (version.length > 1) {
        let trim_Version = parseInt(version[1].replace(/[ ]/g, "").replace(/MSIE/g, ""));
        if (trim_Version <= 9) {
            return true;
        }
    }
    return false;
}
export function invalidSession() {
    if (location.pathname == "/user/reg") {
        location.href = "/user/reg";
    } else {
        if (isClient()) {
            //mac.pc客户端session过期后登出
            jsToNative("LoginOut", '');//JSON.stringify({logout_type: 'invalidsession'})
        }else {
            if(isMobile()) {
                window.location.href = '/user/redirect?uri=' + window.location.pathname + window.location.search;
                return
            }
            //window.location.href = "/user/login";
        }
    }
}

export function getLanguage() {
    let cookieLang = Cookie.get('language'),
        localLang = window.localStorage.getItem('language');
    if (cookieLang && (cookieLang !== 'zh' && cookieLang !== 'en' && cookieLang !== 'tw')) {
        cookieLang = 'zh';
    }
    if (localLang && (localLang !== 'zh' && localLang !== 'en' && localLang !== 'tw')) {
        localLang = 'zh';
    }
    return cookieLang || localLang || 'zh';
}


//实现深拷贝函数
export function deepClone(data) {
    const type = judgeType(data);
    let obj = null;
    if (type == 'array') {
        obj = [];
        for (let i = 0; i < data.length; i++) {
            obj.push(deepClone(data[i]));
        }
    } else if (type == 'object') {
        obj = {}
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                obj[key] = deepClone(data[key]);
            }
        }
    } else {
        return data;
    }
    return obj;
}

function judgeType(obj) {
    // tostring会返回对应不同的标签的构造函数
    const toString = Object.prototype.toString;
    const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object',
    };
    if (obj instanceof Element) {
        return 'element';
    }
    return map[toString.call(obj)];
}



// WEBPACK FOOTER //
// ./static/js/util/util.js